// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"df6d3cbd","455":"7e4bc327","977":"28f595a2"}[chunkId] + ".chunk.js";
};